<template>
    <div class="te-product-price-list">
        <div class="te-product" v-if="productDefinition">
            <span class="te-product__name">{{productDefinition.name}}</span>
        </div>

        <order-messages></order-messages>

        <coupon :order="order" :language="languageSettings"></coupon>

        <price-list v-if="availablePrices" :prices="productPriceList" :language="language" @add="onAddToCart"></price-list>

        <div v-if="message">{{message}}</div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import PriceList from './PriceList';
    import Coupon from './Coupon';
    import OrderMessages from './OrderMessages';

    export default {
        name: "ProductPriceList",

        components: {
            PriceList,
            Coupon,
            OrderMessages,
        },

        data() {
            return {
                token: null,
                // validatingToken: false,
// validatingToken: true,
            };
        },

        props: {
            salesChannelId: {
                type: String,
                required: true
            },
            registerId: {
                type: String,
                required: true
            },
            productDefinitionId: {
                type: String,
                required: true
            },
            orderId: {
                type: String
            },
            customerId: {
                type: String
            },
            preferredLanguageCode: {
                type: String
            },
            language: {
                type: Object
            },
            defaultQuantity: {
                type: Number,
                default: 0
            },
        },

        computed: {
            ...mapGetters({
                error: 'error',
                jobs: 'jobs',
                productDefinition: 'productDefinition',
                order: 'order',
                orderIdFromState: 'orderId',
                priceList: 'productPriceList'
            }),

            productPriceList: function() {
                let quantity = this.defaultQuantity;
                if(quantity === 0 && this.priceList.length === 1) quantity = 1;
                return !this.priceList ? [] : this.priceList.map(p => {
                    return {
                        conditionId: p.conditionId,
                        type: "product",
                        amount: p.price,
                        currency: p.currency,
                        tax: p.tax,
                        description: p.description,
                        // quantity: 0,
                        quantity: quantity,
                        limit: p.limit,
                        conditionPath: p.conditionPath,
                        productDefinitionId: p.productDefinition.id,
                    }
                });
            },

            availablePrices: function() {
                return this.productPriceList && this.productPriceList.length > 0;
            },

            message: function() {
                if(!this.availablePrices) return this.languageSettings.noPrices;
                return null;
            },

            languageSettings: function() {
                const defaultSettings = {
                    noPrices: 'No prices found.',
                    free: 'Free',
                };
                return Object.assign(defaultSettings, this.language);
            },
        },

        methods: {
            ...mapActions([
                "getProductPriceList",
                "getProductDefinition",
                "getOrder",
                "getOrderMessages",
                "addItemsToCart",
                // "addOrderToken"
            ]),

            onAddToCart(productPriceList) {
                const items = this.getAddItems(productPriceList);
                this.addItemsToCart({items});
                this.$emit('add', items);
            },

            getAddItems(productPriceList) {
                const cartItems = [];
                productPriceList.forEach(p => {
                    for (let i = 0; i < p.quantity; i++) {
                        cartItems.push({
                            aggregateId: this.orderIdFromState,
                            productDefinitionId: p.productDefinitionId,
                            requestedConditionPath: p.conditionPath,
                        })
                    }
                });
                return cartItems;
            },

            // async addToken() {
            //     // await this.addOrderToken({
            //     //     token: this.token
            //     // });
            // },
            //
            // getAddedTokens(order) {
            //     // const isInFinalState = new IsInFinalState();
            //     // return order && !isInFinalState.validate(order) && order.tokens !== null ? order.tokens.map(t => t.token).join(', ') : null;
            // },

            async loadData() {
                const orderId = this.orderId ? this.orderId : this.orderIdFromState ? this.orderIdFromState : null;

                // get price list
                await this.getProductPriceList({productDefinitionId: this.productDefinitionId, customerId: this.customerId, salesChannelId: this.salesChannelId, preferredLanguageCode: this.preferredLanguageCode});

                // get product definition
                if(this.productDefinitionId) {
                    this.getProductDefinition({productDefinitionId: this.productDefinitionId});
                }

                // get order
                if(orderId) {
                    this.getOrder({orderId: orderId, forceReload: true});
                }

                // get order messages
                this.getOrderMessages({stage: 'PriceList', orderId, productDefinitionId: this.productDefinitionId, customerId: this.customerId, salesChannelId: this.salesChannelId, preferredLanguage: this.preferredLanguageCode});
            },

        },

        created() {
            this.loadData();
            // const orderId = this.orderId ? this.orderId : this.orderIdFromState ? this.orderIdFromState : null;
            //
            // // get price list
            // this.getProductPriceList({productDefinitionId: this.productDefinitionId, customerId: this.customerId, salesChannelId: this.salesChannelId, preferredLanguageCode: this.preferredLanguageCode});
            //
            // // get product definition
            // if(this.productDefinitionId) {
            //     this.getProductDefinition({productDefinitionId: this.productDefinitionId});
            // }
            //
            // // get order
            // if(orderId) {
            //     this.getOrder({orderId: orderId, forceReload: true});
            // }
            //
            // // get order messages
            // this.getOrderMessages({stage: 'PriceList', orderId, productDefinitionId: this.productDefinitionId, customerId: this.customerId, salesChannelId: this.salesChannelId, preferredLanguage: this.preferredLanguageCode});
        }
    }
</script>

<style scoped>

</style>
